// 子仓库-客户管理
import to from 'await-to-js';
import * as apis from "@/api/interface/customer";
import { CODES } from "@/api/base/codes";
// import * as mock from "@/api/mock/customer";

let updateLastGetQwChatUserListTimestamp = 0; //上次获取客户列表的时间，用于处理异步数据竞态

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    complaintDetail: undefined, //投诉客户详情-详情信息
    assgnRecordList: undefined, //投诉客户详情-下发列表
    telephoneRecordList: undefined, //投诉客户详情-通话记录列表
    collisionRecordList: undefined, //投诉客户详情-撞库记录列表
    smsRecordList: undefined, //投诉客户详情-短信记录列表
    zxPolicyList: undefined, //投诉客户详情-赠险保单列表
    ffxPolicyList: undefined, //投诉客户详情-付费险保单列表
    ffxPolicyPayRecordList: undefined, //投诉客户详情-付费险保单缴费列表
    ffxPolicyRefundRecordList: undefined, //投诉客户详情-付费险保单退费列表
    ffxPolicyResignRecordList: undefined, //投诉客户详情-付费险保单签约解约列表
    traceList: undefined, //投诉客户详情-可回溯记录列表
    cardNoList: undefined, //投诉客户详情-扣款记录查询
    userTimeline: undefined, //投诉客户详情-用户视图与行为时间链

    workOrderList: undefined, //投诉工单管理-工单列表
    workOrderLogList: undefined, //投诉工单管理-工单日志列表
    orderVoiceNavigationList: undefined, //投诉工单管理-工单语音导航对话列表
    workOrderPolicyList: undefined, //投诉工单管理-工单保单列表
    workOrderPolicyChargeRecordList: undefined, //投诉工单管理-工单保单扣费记录列表
    workOrderCompliantList: undefined, //投诉工单管理-投诉列表
    workOrderStats: undefined, //投诉工单管理-工单数据统计

    blackList: undefined, //黑名单管理-列表
    qwChatUserList: undefined, //企微聊天用户列表
    qwQuickReplyList: undefined, //快捷回复列表
    qwCartMsgList: undefined, //工单卡片列表
    offlineRefundPolicy: undefined, //获取线下退费的保单详情

    offlineRefundList: undefined, //退款失败用户 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
    // 更新企微聊天用户列表
    updateQwChatUserList(state, initPayload={}){
      const {talkWeixinInfoId, payload={}} = initPayload;
      const {qwChatUserList} = state;
      if (!qwChatUserList) return;
      const {list} = qwChatUserList;
      if (!Array.isArray(list)) return;

      state.qwChatUserList.list = list.map(item => {
        if (talkWeixinInfoId && talkWeixinInfoId === item.talkWeixinInfoId) return {...item, ...payload};
        return item;
      })
    }
  },
  actions: {
    // 投诉客户详情-详情信息
    async getComplaintDetail(ctx, payload = {}) {
      const [err, res] = await to(apis.getComplaintDetail(payload))
      ctx.commit("update", {
        complaintDetail: !err && res.data ? res.data : undefined
      });
    },
    // 投诉客户详情-发送短信
    async sendSms(ctx, payload = {}) {
      const [, res] = await to(apis.sendSms(payload));
      return res;
    },
    // 投诉客户详情-下发列表
    async getAssgnRecordList(ctx, payload = {}) {
      const [err, res] = await to(apis.getAssgnRecordList(payload));
      ctx.commit("update", {
        assgnRecordList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-通话记录列表
    async getTelephoneRecordList(ctx, payload = {}) {
      const [err, res] = await to(apis.getTelephoneRecordList(payload));
      ctx.commit("update", {
        telephoneRecordList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-撞库记录列表
    async getCollisionRecordList(ctx, payload = {}) {
      const [err, res] = await to(apis.getCollisionRecordList(payload))
      ctx.commit("update", {
        collisionRecordList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-短信记录列表
    async getSmsRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getSmsRecordList(payload));
      ctx.commit("update", {
        smsRecordList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-赠险保单列表
    async getZxPolicyList(ctx, payload = {}) {
      const [err, res] = await to (apis.getZxPolicyList(payload));
      ctx.commit("update", {
        zxPolicyList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-付费险保单列表
    async getFfxPolicyList(ctx, payload = {}) {
      const [err, res] = await to (apis.getFfxPolicyList(payload));
      ctx.commit("update", {
        ffxPolicyList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-获取付费险保单下载链接
    async getFfxPolicyDownUrl(ctx, payload = {}) {
      const [, res] = await to (apis.getFfxPolicyDownUrl(payload));
      return res;
    },
    // 投诉客户详情-保单记录-是否能导出保单退款说明
    async canExportComplaintExplanation(_ctx, payload = {}) {
      const [, res] = await to (apis.canExportComplaintExplanation(payload));
      return res;
    },
    // 投诉客户详情-保单记录-导出保单退款说明
    async exportComplaintExplanation(_ctx, payload = {}) {
      const [, res] = await to (apis.exportComplaintExplanation(payload));
      return res;
    },
    // 投诉客户详情-付费险保单缴费列表
    async getFfxPolicyPayRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getFfxPolicyPayRecordList(payload));
      ctx.commit("update", {
        ffxPolicyPayRecordList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-付费险保单退费列表
    async getFfxPolicyRefundRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getFfxPolicyRefundRecordList(payload));
      ctx.commit("update", {
        ffxPolicyRefundRecordList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 投诉客户详情-付费险保单签约解约列表
    async getFfxPolicyResignRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getFfxPolicyResignRecordList(payload));
      ctx.commit("update", {
        ffxPolicyResignRecordList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-付费险保单解约
    async ffxPolicyRemoveSign(ctx, payload = {}) {return await apis.ffxPolicyRemoveSign(payload);},
    // 投诉客户详情-付费险保单恢复签约
    async ffxPolicyRecoverSign(ctx, payload = {}) {return await apis.ffxPolicyRecoverSign(payload);},
    // 投诉客户详情-付费险保单撤回退费
    async ffxPolicyCancelRefund(ctx, payload = {}) {return await apis.ffxPolicyCancelRefund(payload);},
    // 投诉客户详情-退费期次选项
    async getRefundIssueOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getRefundIssueOptions(payload));
      return res;
    },
    // 投诉客户详情-退全部保费
    async policyRefundAll(ctx, payload = {}) {
      const [, res] = await to (apis.policyRefundAll(payload));
      return res;
    },
    // 投诉客户详情-取消升级
    async policyCancelUpgrade(ctx, payload = {}) {
      const [, res] = await to (apis.policyCancelUpgrade(payload));
      return res;
    },
    // 获取保单详情
    async refundPriceQuery(ctx, payload = {}) {
      const [, res] = await to (apis.refundPriceQuery(payload));
      return res;
    },
    // 投诉客户详情-退指定期次保费
    async policyRefundIssue(ctx, payload = {}) {
      const [, res] = await to (apis.policyRefundIssue(payload));
      return res;
    },
    // 投诉客户详情 - 发送营销短险
    async policySendMarketingSms(ctx, payload = {}) {
      const [, res] = await to(apis.policySendMarketingSms(payload));
      return res;
    },
    // 投诉客户详情-可回溯记录列表
    async getTraceList(ctx, payload = {}) {
      const [err, res] = await to (apis.getTraceList(payload));
      ctx.commit("update", {
        traceList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-扣款记录查询列表
    async getCardNoList(ctx, payload = {}) {
      const [err, res] = await to (apis.getCardNoList(payload));
      ctx.commit("update", {
        cardNoList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉客户详情-用户视图与行为时间链
    // 入参 AnchorQueryRequest：customerId / md5Phone / phone / systemId 任一即可
    async getUserTimeline(ctx, payload = {}) {
      const [err, res] = await to (apis.getUserTimeline(payload));
      ctx.commit("update", {
        userTimeline: !err && res.data ? res.data : undefined,
      });
    },




    // 投诉工单管理-筛选选项枚举
    async getWorkOrderOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getWorkOrderOptions(payload));
      return res;
    },
    // 投诉工单管理-来源位置选项
    async getTsPositionOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getTsPositionOptions(payload));
      return res;
    },
    async getCustomerInfo(ctx, payload = {}) {
      const [, res] = await to (apis.getCustomerInfo(payload));
      return res;
    },
    async batchClaim(ctx, payload = {}) {
      const [, res] = await to (apis.batchClaim(payload));
      return res;
    },
    // 投诉工单管理-获取可被指派人员列表
    async getBeAssignUserOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getBeAssignUserOptions(payload));
      return res;
    },
    // 投诉工单管理-工单列表
    async getWorkOrderList(ctx, payload = {}) {
      const [err, res] = await to (apis.getWorkOrderList(payload));
      ctx.commit("update", {
        workOrderList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉工单管理-工单语音导航对话列表
    async getOrderVoiceNavigationList(ctx, payload = {}) {
      const [err, res] = await to (apis.getOrderVoiceNavigationList(payload));
      ctx.commit("update", {
        orderVoiceNavigationList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉工单管理-工单保单列表
    async getWorkOrderPolicyList(ctx, payload = {}) {
      const [err, res] = await to (apis.getWorkOrderPolicyList(payload));
      ctx.commit("update", {
        workOrderPolicyList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 投诉工单管理-工单保单扣费记录列表
    async getWorkOrderPolicyChargeRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getWorkOrderPolicyChargeRecordList(payload));
      ctx.commit("update", {
        workOrderPolicyChargeRecordList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    //投诉工单管理-投诉列表
    async getWorkOrderCompliantList(ctx, payload = {}) {
      const [err, res] = await to (apis.getWorkOrderCompliantList(payload));
      ctx.commit("update", {
        workOrderCompliantList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    //投诉工单管理-添加投诉
    async workOrderCompliantAdd(ctx, payload = {}) {
      const [, res] = await to (apis.getWorkOrderCompliantList(payload));
      return res;
    },
    // 投诉工单管理-保单信息带出
    async getWorkOrderPolicyInfo(ctx, payload = {}) {
      const [, res] = await to (apis.getWorkOrderPolicyInfo(payload));
      return res;
    },
    // 投诉工单管理-工单添加、修改
    async addWorkOrder(ctx, payload = {}) {
      const [, res] = await to(apis.addWorkOrder(payload));
      return res;
    },
    // 投诉工单管理-工单状态变更
    async changeWorkOrder(ctx, payload = {}) {
      const [, res] = await to(apis.changeWorkOrder(payload));
      return res;
    },
    // 投诉工单管理-工单日志列表
    async getWorkOrderLogList(ctx, payload = {}) {
      const [err, res] = await to (apis.getWorkOrderLogList(payload));
      ctx.commit("update", {
        workOrderLogList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉工单管理-工单导出
    async exportWorkOrder(ctx, payload = {}) {return apis.exportWorkOrder(payload)},
    // 投诉工单管理-是否能拨打
    async canCallCheck(ctx, payload = {}) {
      const [, res] = await to (apis.canCallCheck(payload));
      return res;
    },
    // 投诉工单管理-工单数据统计
    async getWorkOrderStats(ctx, payload = {}) {
      const [err, res] = await to (apis.getWorkOrderStats(payload));
      ctx.commit("update", {
        workOrderStats: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 投诉工单管理-未接短信发送
    async sendSmsToNoAccept(_, payload = {}) {
      const [, res] = await to (apis.sendSmsToNoAccept(payload));
      return res;
    },
    // 投诉工单管理-复效
    async recoverOrderFromTimeout(_, payload = {}) {
      const [, res] = await to (apis.recoverOrderFromTimeout(payload));
      return res;
    },
    // 投诉工单管理-通话记录上报
    async updateCallRecord(_, payload = {}) {
      const [, res] = await to (apis.updateCallRecord(payload));
      return res;
    },


    // 黑名单管理-列表
    async getBlackList(ctx, payload = {}) {
      const [err, res] = await to (apis.getBlackList(payload));
      ctx.commit("update", {
        blackList: !err && res.data ? res.data : undefined,
      });
    },
    // 黑名单管理-模板下载
    async blackTemplateDown(ctx, payload = {}) {return await apis.blackTemplateDown(payload);},
    // 黑名单管理-excel上传数据
    async blackExcelUpload(ctx, payload = {}) {return apis.blackExcelUpload(payload)},
    // 黑名单管理-批量新增
    async blackBatchAdd(ctx, payload = {}) {
      const [, res] = await to(apis.blackBatchAdd(payload));
      return res;
    },
    // 黑名单管理-删除
    async blackBachDelete(ctx, payload = {}) {
      const [, res] = await to(apis.blackBachDelete(payload));
      return res;
    },



    // 敏感信息转码
    async sensitiveDataOperate(ctx, payload = {}) {
      const [, res] = await to(apis.sensitiveDataOperate(payload));
      return res;
    },




    // 企微消息 - 获取签到状态
    async getQwClockIn(_ctx, payload = {}) {
      const [, res] = await to (apis.getQwClockIn(payload));
      return res;
    },
    // 企微消息 - 签到状态变更
    async qwClockInUpdate(_ctx, payload = {}) {
      const [, res] = await to (apis.qwClockInUpdate(payload));
      return res;
    },
    // 企微消息 - 获取企微用户列表
    async getQwChatUserList(ctx, payload = {}) {
      const timestamp = Date.now();
      updateLastGetQwChatUserListTimestamp = timestamp;
      const [err, res] = await to (apis.getQwChatUserList(payload));
      if (timestamp < updateLastGetQwChatUserListTimestamp) return;
      ctx.commit("update", {
        qwChatUserList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 企微消息 - 获取线下退费用户列表
    async getQwOfflineRefundUserList(ctx, payload = {}) {
      const timestamp = Date.now();
      updateLastGetQwChatUserListTimestamp = timestamp;
      const [err, res] = await to (apis.getQwOfflineRefundUserList(payload));
      if (timestamp < updateLastGetQwChatUserListTimestamp) return;
      ctx.commit("update", {
        qwChatUserList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 企微消息 - 线下退费 - 用户列表 - 导出
    async qwOfflineRefundUserExport(_ctx, payload = {}) {
      const [, res] = await to (apis.qwOfflineRefundUserExport(payload));
      return res;
    },

    // 企微消息 - 获取聊天列表 / 聊天被占用情况
    async getQwChatList(_ctx, payload = {}) {
      const [, res] = await to (apis.getQwChatList(payload));
      return res;
    },
    // 企微消息 - 发送聊天消息
    async sendQwChatMsg(_ctx, payload = {}) {
      const [, res] = await to (apis.sendQwChatMsg(payload));
      return res;
    },
    // 企微消息 - 发送图文卡片 (后台直接发送，不需要把相关信息返回给前端，前端再调发送聊天消息接口发送)
    async sendQwChatImgLinkCard(_ctx, payload = {}) {
      const [, res] = await to (apis.sendQwChatImgLinkCard(payload));
      return res;
    },
    // 企微消息 - 消息撤回
    async qwChatRecall(_ctx, payload = {}) {
      const [, res] = await to (apis.qwChatRecall(payload));
      return res;
    },
    // 企微消息 - 上传图片
    async qwChatUploadImg(_ctx, payload = {}) {
      const [, res] = await to (apis.qwChatUploadImg(payload));
      return res;
    },
    // 企微消息 - 获取聊天快捷发送图文链接的卡片列表
    async getQwCartMsgList(ctx, payload = {}) {
      const [err, res] = await to (apis.getQwCartMsgList(payload));
      ctx.commit("update", {
        qwCartMsgList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 企微消息 - 标星状态变更
    async qwChatMarkUpdate(_ctx, payload = {}) {
      const [, res] = await to (apis.qwChatMarkUpdate(payload));
      return res;
    },
    // 企微消息 - 线下退费客户 - 用户已接受退款成功金额
    async acceptRefundSuccess(_ctx, payload = {}) {
      const [, res] = await to (apis.acceptRefundSuccess(payload));
      return res;
    },

    // 企微消息 - 获取快捷回复列表
    async getQwQuickReplyList(ctx, payload = {}) {
      const [err, res] = await to (apis.getQwQuickReplyList(payload));
      ctx.commit("update", {
        qwQuickReplyList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 企微消息 - 获取快捷回复类别选项列表
    async getQwQuickReplyTypeOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getQwQuickReplyTypeOptions(payload));
      return res;
    },

    // 企微消息 - 获取线下退费的保单详情
    async getOfflineRefundPolicy(ctx, payload = {}) {
    const [err, res] = await to (apis.getOfflineRefundPolicy(payload));
      ctx.commit("update", {
        offlineRefundPolicy: !err && res.code === CODES.SUCCESS ? res.data : undefined,
      });
      return res;
    },




    // 退款失败用户 - 列表
    async getOfflineRefundList(ctx, payload = {}) {
      const [err, res] = await to (apis.getOfflineRefundList(payload));
      ctx.commit("update", {
        offlineRefundList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 退款失败用户 - 列表导出
    async exportOfflineRefundList(_ctx, payload = {}) {return apis.exportOfflineRefundList(payload)},
    // 退款失败用户-飞书审批用户导入
    async updateFsspRefundUser(_ctx, payload = {}) {
      const [, res] = await to(apis.updateFsspRefundUser(payload));
      return res;
    },
    // 退款失败用户 - 获取客户详情
    // async getCustomerDetail(_ctx, payload = {}) {return apis.getCustomerDetail(payload)},
    // 退款失败用户 - 获取保单退费期次详情
    // async getPolicyIssueDetail(_ctx, payload = {}) {return apis.getPolicyIssueDetail(payload)},
    // 退款失败用户 - 查询可退费数据
    async queryOfflineRefundCustomer(_ctx, payload = {}) {return apis.queryOfflineRefundCustomer(payload)},
    // 退款失败用户 - 获取线下退费详情
    async getOfflineRefundDetail(_ctx, payload = {}) {return apis.getOfflineRefundDetail(payload)},
    // 退款失败用户 - 新增
    async offlineRefundAdd(_ctx, payload = {}) {return apis.offlineRefundAdd(payload)},
    // 退款失败用户 - 企微消息 - 发送图文卡片 (后台直接发送，不需要把相关信息返回给前端，前端再调发送聊天消息接口发送)
    async orSendQwChatImgLinkCard(_ctx, payload = {}) {
      const [, res] = await to (apis.orSendQwChatImgLinkCard(payload));
      return res;
    },
    // 退款失败用户 - 查询微信用户列表
    async queryOfflineRefundWxUserList(_ctx, payload = {}) {
      const [, res] = await to(apis.queryOfflineRefundWxUserList(payload));
      return res;
    },
    // 退款失败用户 - 绑定微信用户
    async bindOfflineRefundWxUser(_ctx, payload = {}) {
      const [, res] = await to(apis.bindOfflineRefundWxUser(payload));
      return res;
    },
  },
  modules: {},
};
